import Contact from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Footer/Contact"
import Overview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Footer/Overview"
import SocialLinks from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/Footer/SocialLinks";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";

const Footer = () => {
    const { templatePayload } = useMicroSiteContext();
  
  return (
    <div className="flex flex-col gap-4 p-4 lg:p-8 xl:p-16">
      <div className="flex justify-between gap-4 flex-wrap">
        <img src={templatePayload.branding.websiteLogoUrl} alt="logo" className="h-12 min-w-fit w-fit object-contain" />
        <Overview />
      </div>

      <hr className="border-t border-gray-300 my-4 " />

<div className="grid lg:grid-cols-2 justify-between gap-8">
      <Contact />
    <SocialLinks />
</div>
    </div>
  )
}

export default Footer